var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "subscription-activity-view flex-between-wrapper" },
    [
      _c("div", { staticClass: "premium-activity-view" }, [
        _c("h3", { staticClass: "view-title" }, [
          _vm._v("Set a reading routine for your class"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "view-description" }, [
          _vm._v(
            "Practice makes perfect! With recurring activities and point goals, you can set a weekly reading routine that gives students regular practice. Easily check progress in real-time to see students’ performance!"
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "button-wrapper" },
          [
            _c("primary-button", { on: { click: _vm.handleClickPlan } }, [
              _vm._v("Choose your plan"),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "feature-image",
        attrs: { src: "/assets/app/class/activity-frame-bg.png" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }